import { GANTT_BIND_TYPE_LIST } from '@gantt/components/GanttCreateOrEdit/types'

export function getKeyByBindType(bindType: GANTT_BIND_TYPE_LIST) {
  if (Object.values(GANTT_BIND_TYPE_LIST).includes(bindType)) {
    return bindType
  }

  return GANTT_BIND_TYPE_LIST.FIELD
}
